export default __webpack_public_path__ + "static/media/menu2.d0fc6f52.svg";